"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_Claim_Insurance = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_positiveInt_1 = require("../Scalar/RTTI_positiveInt");
var RTTI_Element_1 = require("./RTTI_Element");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_Reference_1 = require("./RTTI_Reference");
exports.RTTI_Claim_Insurance = t.recursion('IClaim_Insurance', function () {
    return t.intersection([
        t.type({
            coverage: RTTI_Reference_1.RTTI_Reference
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            sequence: RTTI_positiveInt_1.RTTI_positiveInt,
            _sequence: RTTI_Element_1.RTTI_Element,
            focal: t.boolean,
            _focal: RTTI_Element_1.RTTI_Element,
            identifier: RTTI_Identifier_1.RTTI_Identifier,
            businessArrangement: t.string,
            _businessArrangement: RTTI_Element_1.RTTI_Element,
            preAuthRef: t.array(t.string),
            _preAuthRef: t.array(RTTI_Element_1.RTTI_Element),
            claimResponse: RTTI_Reference_1.RTTI_Reference
        })
    ]);
});
//# sourceMappingURL=RTTI_Claim_Insurance.js.map